import React from "react"
import PropTypes from "prop-types"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import { convertValueToReadable } from "services/units/valueConversion"
import { CO2_EMISSION_UNITS, T_CO2E } from "services/units/units"
import { round } from "services/units/round"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const TRANSLATION_PREFIX = "analyze:common.kpis.emissions_per_key_metric"

const TextChartODD13EmissionsPerKeyMetricMolecule = ({
  emissions,
  keyMetricFigure,
  keyMetricUnit,
  trendBadge,
}) => {
  const { t } = useTranslation()

  const emissionsPerKeyMetric = emissions / keyMetricFigure
  const { unit, value: kpi } = convertValueToReadable(
    emissionsPerKeyMetric,
    T_CO2E,
    CO2_EMISSION_UNITS,
    round
  )

  const content = {
    kpi_text: t(`${TRANSLATION_PREFIX}.title`),
    kpi,
    kpi_unit: `${t(`units:units.emission.${unit}`)} / ${keyMetricUnit}`,
  }

  return (
    <HelpWidgetChartInteractiveMolecule text={t(`${TRANSLATION_PREFIX}.help`)}>
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto">
        <TextChart
          content={<TextChartMinor content={content} noSubtextHover={true} />}
        />
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

TextChartODD13EmissionsPerKeyMetricMolecule.propTypes = {
  emissions: PropTypes.number.isRequired,
  keyMetricFigure: PropTypes.number.isRequired,
  keyMetricUnit: PropTypes.string.isRequired,
  trendBadge: PropTypes.object,
}

TextChartODD13EmissionsPerKeyMetricMolecule.defaultProps = {
  trendBadge: null,
}

export default TextChartODD13EmissionsPerKeyMetricMolecule
